import { motion } from "framer-motion";

const EASE = [0.33, 1, 0.68, 1];

const Manifesto = () => {
  return (
    <section
      id="vision"
      data-testid="manifesto-section"
      className="relative overflow-hidden border-t border-white/10 bg-surface py-32 md:py-44"
    >
      <span className="pointer-events-none absolute -right-10 top-8 select-none font-display text-[26rem] font-bold leading-none text-white/[0.03]">
        01
      </span>

      <div className="relative mx-auto max-w-[1600px] px-6 md:px-12">
        <div className="grid grid-cols-1 gap-16 lg:grid-cols-12">
          <div className="lg:col-span-4">
            <motion.p
              initial={{ opacity: 0, x: -24 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.8, ease: EASE }}
              className="font-mono text-xs uppercase tracking-[0.35em] text-neon md:text-sm"
              data-testid="manifesto-overline"
            >
              // THE VISION
            </motion.p>
            <motion.div
              initial={{ scaleY: 0 }}
              whileInView={{ scaleY: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 1, delay: 0.2, ease: EASE }}
              className="mt-8 h-40 w-px origin-top bg-gradient-to-b from-cyber to-transparent"
            />
            <motion.p
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8, delay: 0.4 }}
              className="mt-8 font-mono text-[10px] uppercase tracking-[0.3em] text-white/30"
            >
              Chapter 01 — Corporate Manifesto
            </motion.p>
          </div>

          <div className="lg:col-span-8">
            <motion.h2
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.9, ease: EASE }}
              className="font-display text-3xl font-medium leading-[1.05] tracking-tight sm:text-4xl md:text-6xl"
              data-testid="manifesto-headline"
            >
              One Core Engine.
              <br />
              <span className="text-outline">Five Pillars of Progress.</span>
            </motion.h2>

            <motion.p
              initial={{ opacity: 0, y: 32 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.9, delay: 0.15, ease: EASE }}
              className="mt-12 max-w-2xl text-base leading-relaxed text-secondary md:text-lg"
              data-testid="manifesto-body"
            >
              We do not limit our thinking to a single market. Future Factory
              Group functions as an integrated ecosystem designed to solve
              humanity's fundamental demands. By uniting next-generation
              digital architecture with the physical power of manufacturing,
              clean energy, agriculture, and real estate, we are constructing
              a cross-disciplinary framework for a smarter world.
            </motion.p>

            <motion.div
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 1, delay: 0.35 }}
              className="mt-14 flex flex-wrap gap-x-12 gap-y-4 font-mono text-[10px] uppercase tracking-[0.25em] text-white/35"
            >
              <span data-testid="manifesto-tag-software">Software</span>
              <span className="text-cyber">×</span>
              <span data-testid="manifesto-tag-manufacturing">Manufacturing</span>
              <span className="text-cyber">×</span>
              <span data-testid="manifesto-tag-energy">Energy</span>
              <span className="text-cyber">×</span>
              <span data-testid="manifesto-tag-agriculture">Agriculture</span>
              <span className="text-cyber">×</span>
              <span data-testid="manifesto-tag-realestate">Real Estate</span>
            </motion.div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Manifesto;
